import { render } from "./TicketPrintCountDetails.vue?vue&type=template&id=223de6b0&scoped=true"
import script from "./TicketPrintCountDetails.vue?vue&type=script&lang=js"
export * from "./TicketPrintCountDetails.vue?vue&type=script&lang=js"

import "./TicketPrintCountDetails.vue?vue&type=style&index=0&id=223de6b0&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223de6b0"]])

export default __exports__